import * as React from "react";

function SvgStonly(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 19 18"
      {...{ ...props, ref }}
    >
      <path
        d="M13.741 7.493a1.836 1.836 0 00-1.831 1.831c0 1.007.823 1.832 1.831 1.832a1.837 1.837 0 001.831-1.832 1.836 1.836 0 00-1.831-1.83M8.24 7.493H4.578a1.836 1.836 0 00-1.831 1.831c0 1.008.824 1.831 1.83 1.831H8.24a1.836 1.836 0 001.831-1.83 1.836 1.836 0 00-1.83-1.832M10.987.779H7.325A1.836 1.836 0 005.494 2.61c0 1.008.823 1.832 1.83 1.832h3.663a1.836 1.836 0 001.83-1.832 1.836 1.836 0 00-1.83-1.831M7.33 14.207c-1.007 0-1.83.824-1.83 1.832 0 1.007.823 1.831 1.83 1.831h9.16c1.007 0 1.83-.824 1.83-1.831a1.836 1.836 0 00-1.83-1.832H7.33zm-5.499 0A1.837 1.837 0 000 16.04c0 1.007.824 1.831 1.831 1.831a1.837 1.837 0 001.831-1.831 1.837 1.837 0 00-1.831-1.832"
        fill="#FF4A75"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default React.forwardRef(SvgStonly);
